import { useMemo } from "react";
import {
    NavigationContext,
    NavigationSectionConfig,
    SectionContext,
} from "../types/Navigation.types";
import { useRouter } from "@/utils/router";

export function useNavigationContext(
    config: NavigationSectionConfig[],
): NavigationContext {
    const { pathname, isPathMatch, params } = useRouter();

    const sections: SectionContext[] = useMemo(() => {
        return config.map(({ label, regex, getHref }) => ({
            label,
            href: getHref(params),
            regex,
            isCurrent: isPathMatch(regex),
        }));
    }, [pathname, isPathMatch, config, params]);

    return {
        sections,
    };
}
